import CarouselHeader from './CarouselHeader';

export default CarouselHeader;
